module.exports = __webpack_public_path__ + "img/david-darmanin.39cbab80.png";